import { ICartTrack } from '../Interface/track'

// this object simplyfied adding to cart
export class CartItem {
  beatId: number
  licenseId: string

  constructor(id, licenseId) {
    this.beatId = id
    this.licenseId = licenseId
  }
}

// this object for request to make sure that all items inside the cart haven't changed
export class BeatForCheck {
  beatId: number
  licenseId: string
  price: number

  constructor(beatid, licenseid, price) {
    this.beatId = beatid
    this.licenseId = licenseid
    this.price = price
  }
}

// for each beatmaker sections
export class CartGroup {
  beatmakerId: number
  beatmakerName: string
  beats: ICartTrack[]

  constructor(beatmakerId, beamakerName, beats) {
    this.beatmakerId = beatmakerId
    this.beatmakerName = beamakerName
    this.beats = beats
  }
}

// this object for server request
export class CheckRequest {
  beatmakerId: number
  beats: BeatForCheck[]

  constructor(id, beatsForCheck) {
    this.beatmakerId = id
    this.beats = beatsForCheck
  }
}

// response after the check request
export class CheckingResult extends BeatForCheck {
  isOk: boolean
  message: string
}
